import { motion } from 'framer-motion';
import { FaEye, FaEdit } from 'react-icons/fa';
import { Section, SectionContent } from '@/contexts/ContentContext';
import React from 'react';

interface ContentSectionProps {
  section: Section;
  previewMode: boolean;
  onTogglePreview: () => void;
  onContentChange: (field: string, value: any) => void;
  // Funções opcionais para manipulação de arrays
  onArrayItemChange?: never;
  onAddItem?: never;
  onRemoveItem?: never;
  renderPreview: (content: SectionContent) => React.ReactNode;
  renderForm: (content: SectionContent) => React.ReactNode;
}

export function ContentSection({
  section,
  previewMode,
  onTogglePreview,
  renderPreview,
  renderForm,
}: ContentSectionProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="rounded-lg bg-white p-6 shadow"
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-gray-900">{section.name}</h3>
        <div className="flex space-x-2">
          <button
            onClick={onTogglePreview}
            className="flex items-center space-x-1 text-sm text-blue-600 hover:text-blue-800"
          >
            {previewMode ? (
              <>
                <FaEdit className="h-4 w-4" />
                <span>Editar</span>
              </>
            ) : (
              <>
                <FaEye className="h-4 w-4" />
                <span>Visualizar</span>
              </>
            )}
          </button>
          <button
            onClick={() => window.open('/', '_blank')}
            className="flex items-center space-x-1 text-sm text-gray-600 hover:text-gray-800"
          >
            <FaEye className="h-4 w-4" />
            <span>Ver no site</span>
          </button>
        </div>
      </div>
      
      {previewMode ? (
        renderPreview(section.content)
      ) : (
        renderForm(section.content)
      )}
    </motion.div>
  );
}
